'use client';

import { Link } from '@/navigation';
import React from 'react';
import useSession from '@/stores/session/useSession';
import { useTranslations } from 'next-intl';
import GiftcardForm from '@/app/[locale]/giftcard/components/GiftcardForm';

export default function() {
  const t = useTranslations('giftcard');
  const { user } = useSession();

  if (!user) {
    return (
      <div className="tw-mt-4 tw-text-center">
        <p>
          <Link href={{pathname: '/auth/signin', query: {redirect: '/giftcard'}}}>
            {t('GiftcardForm.login-1')}
          </Link>
          {t('GiftcardForm.login-2')}
        </p>
      </div>
    );
  }

  return <GiftcardForm />;
}
